// removed by extract-text-webpack-plugin
module.exports = {"Address":"src-components-Footer----Address-module---Address---3QJH-","kssGroup":"src-components-Footer----Address-module---kssGroup---20kjT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Address.module.css
// module id = 373
// module chunks = 114276838955818